export enum ToolTypes {
	NONE			=	"NONE",
	SEEDING 	= "SEEDING"
}